import type { ApiResponse_FetchLeaderboardPurchases_Schema, ApiResponse_FetchLeaderboard_Schema, ApiResponse_FetchLeaderboardSummary_Schema, LeaderboardEntry_Schema, LeaderboardPurchasesEntry_Schema, UserStanding_Schema } from "@/services/user/leaderboard/leaderboardSchema";
import type { CurrencyId } from "@/services/currencies/currenciesTypes";
import type { UserId } from "@/services/user/userTypes";
import type { z } from "zod";

export type UserStanding = z.infer<typeof UserStanding_Schema>;

export enum Metric {
  CollectionItems = "collection_items",
  MarketplaceItems = "marketplace_items",
  ReceivedLikes = "like_received",
  GivenLikes = "like_given",
  TotalPoints = "points",
  Purchases = "purchases",
}

export type LeaderboardEntry = z.infer<typeof LeaderboardEntry_Schema>;

export type LeaderboardFilter = {
  page: number; // starting with 1
  perPage: number;
  userId: UserId;
  metric: Metric;
  /** Keeps only collectors whose nickname contains this text; ranks stay those of the whole ladder. */
  nickname?: string;
};

export type ApiResponse_FetchLeaderboard = z.infer<typeof ApiResponse_FetchLeaderboard_Schema>;
export type ApiResponse_FetchLeaderboardSummary = z.infer<typeof ApiResponse_FetchLeaderboardSummary_Schema>;

export type LeaderboardPurchasesEntry = z.infer<typeof LeaderboardPurchasesEntry_Schema>;

export type LeaderboardPurchasesFilter = {
  page: number; // starting with 1
  perPage: number;
  userId: UserId;
  week: number; // ISO week number
  year: number; // ISO week-numbering year
  primaryCurrencyId: CurrencyId;
};

export type ApiResponse_FetchLeaderboardPurchases = z.infer<typeof ApiResponse_FetchLeaderboardPurchases_Schema>;
